import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { PageHeader } from '../../components/page-header';
import { BulkReprocessLaunchForm } from '../../contexts/admin';

export function BulkReprocessNewPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col gap-6">
      <div className="space-y-4">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="gap-1.5 pl-0"
          onClick={() => navigate({ to: '/admin/bulk-replay' })}
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.7} />
          Back to runs
        </Button>
        <PageHeader
          title="New Bulk Replay"
          description="Pick a target set of sessions and a processing mode, preview the affected count, then launch."
          size="compact"
        />
      </div>

      <BulkReprocessLaunchForm
        onCreated={(runId) => navigate({ to: '/admin/bulk-replay/$runId', params: { runId } })}
      />
    </div>
  );
}
